<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->


<template>
    <div class="sdev-global-modals">
        <transition-group name="sdev-modal">
            <div v-for="modal in modals" :key="modal.id" class="sdev-modal-overlay">
                <div class="sdev-modal">
                    <component :is="modal.component" v-bind="modal.props" @close="close(modal.id)" />
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script setup>
import { useModal } from '@/composables/useModal'

const { modals, close } = useModal()
</script>